module.exports = __webpack_public_path__ + "static/servers-background-9102ce1b5c28b504a0647dba8b283bf1.png";